// giusp.com grn@giusp.com

import { pass, fail, styleAsIsValid, styleAsIsInvalid } from "./service_commons.js";

let inputElement1Name = "serviceInput";

function precheck_inputElement1(inputElement1) {
    let text = String(inputElement1.value);
    text = text.trim();

    if (text.length == 0 || text.length > 65536) {
        fail("first");
        return false;
    }

    pass("first");
    return true;
}

function precheckStyle_inputElement1(inputElement1) {
    if (precheck_inputElement1(inputElement1)) {
        styleAsIsValid(inputElement1);
    } else {
        styleAsIsInvalid(inputElement1);
    }
}

document.getElementById(inputElement1Name).oninput = function () {
    precheckStyle_inputElement1(this);
};

window.onload = function () {
    let res = precheck_inputElement1(document.getElementById(inputElement1Name));

    if (res) {
        document.getElementById("serviceFormSendButton").removeAttribute("disabled");
    } else {
        document.getElementById("serviceFormSendButton").setAttribute("disabled", "disabled");
    }
};
